import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'hedron';
import Button from '../../Button';

const ClearButton = ({ isDesktop, handleClearFilters }) => (
  <Row data-cy="refine-by-clear-button" style={{ padding: isDesktop ? 0 : '0 5px 0 5px' }}>
    <Column fluid>
      <Button
        bold
        dataCy="button-clear-all-filters"
        padding="0"
        marginText="4px 0 0 0"
        height={isDesktop ? 42 : 44}
        fontSize={13}
        isDesktop={isDesktop}
        border="1px solid lightgrey"
        title="clear all"
        onClick={() => handleClearFilters()}
      />
    </Column>
  </Row>
);

ClearButton.propTypes = {
  handleClearFilters: PropTypes.func,
  isDesktop: PropTypes.bool
};

export default ClearButton;
